///ADHD CURRENT SYMPTOM SURUVEY - ASRS V1.1/////

export const defaultASRSSurveyPartA = [
    {
        text: "How often do you have trouble wrapping up final details of a project, once the challenging parts have been done?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have difficulty getting things in order when you have to do a task that requires organization?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have problems remembering appointments or obligations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
       text: "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?",  
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    { 
        text: "How often do you feel overly active and compelled to do things, like you were driven by a motor?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },    
];

export const defaultASRSSurveyPartB= [
     {
        text: "How often do you make careless mistakes when you have to work on a boring or difficult project?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have difficulty keeping your attention when you are doing boring or repetitive work?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you misplace or have difficulty finding things at home or at work?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often are you distracted by activity or noise around you?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you leave your seat in meetings or other situations in which you are expected to remain seated?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you feel restless or fidgety?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have difficulty unwinding and relaxing when you have time to yourself?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you find yourself talking too much when you are in social situations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When you’re in a conversation, how often do you find yourself finishing the sentences of the people you are talking to, before they can finish them themselves?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you have difficulty waiting your turn in situations when turn taking is required?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often do you interrupt others when they are busy?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    
];



///ADHD CHILD SURVEYS (BASED ON REGULAR ASRS)//////

export const defaultADHDChildSurveyPartA = [
    {
        text: "How often did you make careless mistakes when you had to work on a boring or difficult project?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have difficulty keeping your attention when you were doing boring or repetitive work?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have difficulty concentrating on what people said to you, even when they were speaking to you directly?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have trouble wrapping up the final details of a project, once the challenging parts had been done?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have difficulty getting things in order when you had to do a task that required organization?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When you had a task that required a lot of thought, how often did you avoid or delay getting started?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you misplace or have difficulty finding things at home or at school?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you get distracted by activity or noise around you?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have problems remembering appointments or obligations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
];

export const defaultADHDChildSurveyPartB = [
    {
        text: "How often did you fidget or squirm with your hands or feet when you had to sit down for a long time?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you leave your seat in meetings or other situations in which you were expected to remain seated?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you feel restless or fidgety?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have difficulty unwinding and relaxing when you had time to yourself?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you feel overly active and compelled to do things, like you were driven by a motor?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you find yourself talking too much when you were in social situations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When you’re in a conversation, how often did you find yourself finishing the sentences of the people you were talking to, before they could finish them themselves?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you have difficulty waiting your turn in situations when turn taking is required?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did you interrupt others when they are busy?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
];



//////ADHD PARENT SURVEYS (BASED ON ASRS NORMAL)///////////////

export const defaultADHDParentSurveyPartA = [
    {
        text: "How often did client make careless mistakes when they had to work on a boring or difficult project?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have difficulty keeping their attention when they were doing boring or repetitive work?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have difficulty concentrating on what people said to them, even when people were speaking to them directly?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have trouble wrapping up the final details of a project, once the challenging parts had been done?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have difficulty getting things in order when they had to do a task that required organization?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When client had a task that required a lot of thought, how often did they avoid or delay getting started?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client misplace or have difficulty finding things at home or at school?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client get distracted by activity or noise around them?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have problems remembering appointments or obligations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
];

export const defaultADHDParentSurveyPartB = [
    {
        text: "How often did client fidget or squirm with their hands or feet when they had to sit down for a long time?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client leave their seat in meetings or other situations in which they were expected to remain seated?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client feel restless or fidgety?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have difficulty unwinding and relaxing when they had time to themselves?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client feel overly active and compelled to do things, like they were driven by a motor?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client find themselves talking too much when they were in social situations?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "When client was in a conversation, how often did they find themselves finishing the sentences of the people they were talking to, before the other party could finish them themselves?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client have difficulty waiting their turn in situations when turn taking is required?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How often did client interrupt others when the other parties were busy?",
        answers: ["Never","Rarely","Sometimes","Often","Very Often"],
        choice: 0,
        explanation: "",
    },
];

//////// Y-BOCS ///////////////

// Questions divided into obessions (which comes first) and compulsions
export const defaultYBOCSObsessions= [
    {
        text: "How much time do you spend on obsessive thoughts?",
        answers: ["None","0-1 hrs/day","1-3 hrs/day","3-8 hrs/day","Very > 8 hrs/day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How much do your obsessive thoughts interfere with your personal, social, or work life?",
        answers: ["None","Mild","Definite but manageable","Substantial interference","Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How much do your obsessive thoughts distress you?",
        answers: ["None","Little","Moderate but manageable","Severe","Nearly constant/Disabling"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How hard do you try to resist your obsessions?",
        answers: ["Always try","Try much of the time","Try some of the time","Rarely try/Often yield","Never try/Completely yield"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How much control do you have over your obsessive thoughts?",
        answers: ["Complete control","Much control","Some control","Little control","No control"],
        choice: 0,
        explanation: "",
    },
];

export const defaultYBOCSCompulsions= [
    {
        text: "How much time do you spend performing compulsive behaviors?",
        answers: ["None","0-1 hrs/day","1-3 hrs/day","3-8 hrs/day","> 8 hrs/day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How much do your compulsive behaviors interfere with your personal, social, or work life?",
        answers: ["None","Mild","Definite but manageable","Substantial interference","Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How anxious would you feel if you were prevented from performing your compulsive behaviors?",
        answers: ["None","Little","Moderate but manageable","Severe","Nearly constant/Disabling"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How hard do you try to resist your compulsive behaviors?",
        answers: ["Always try","Try much of the time","Try some of the time","Rarely try/Often yield","Never try/Completely yield"],
        choice: 0,
        explanation: "",
    }, 
    {
        text: "How much control do you have over your compulsive behaviors?",
        answers: ["Complete control","Much control","Some control","Little control","No control"],
        choice: 0,
        explanation: "",
    },
];

////////////
/* Scoring:
If you have both obsessions and compulsions, and your total score is;
8-15 = Mild OCD; 16-23 = Moderate OCD; 24-31= Severe OCD; 32-40 = Extreme OCD */
//////////

// INSOMNIA SEVERITY Inedex 
export const defaultInsomniaSeverityIndex= [
    {
        text: "Rate your difficulty FALLING asleep...",
        answers: ["None","Mild","Moderate", "Severe","Very Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Rate your difficulty STAYING asleep...",
        answers: ["None","Mild","Moderate", "Severe","Very Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Rate your problems WAKING UP too early...",
        answers: ["None","Mild","Moderate", "Severe","Very Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How SATISFIED/DISSATISFIED are you with your CURRENT sleep pattern?",
        answers: ["Very Satisfied","Satisfied","Moderately Satisfied", "Dissatisfied","Very Dissatisfied"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How NOTICEABLE to others do you think your sleep problem is in terms of impairing the quality of your life?",
        answers: ["Not At All","A Little","Somewhat", "Much","Very Much"],
        choice: 0,
        explanation: "",
    },
    {
        text: "How WORRIED/DISTRESSED are you about your current sleep problem?",
        answers: ["Not At All","A Little","Somewhat", "Much","Very Much"],
        choice: 0,
        explanation: "",
    },
    {
        text: "To what extent do you consider your sleep problem to INTERFERE with your daily functioning (e.g. daytime fatigue, mood, ability to function at work/daily chores, concentration, memory, mood, etc.) CURRENTLY?",
        answers: ["Not At All","A Little","Somewhat", "Much","Very Much"],
        choice: 0,
        explanation: "",
    },
];


// DEPRESSION
export const defaultHamD= [
    {
        text: "DEPRESSED MOOD (gloomy attitude, pessimism about the future, feeling of sadness, tendency to weep)",
        answers: ["Absent","Sadness, etc","Occasional weeping", "Frequent weeping","Extreme symptoms"],
        choice: 0,
        explanation: "",
    },
    {
        text: "FEELINGS OF GUILT",
        answers: ["Absent","Self-reproach, feels he/she has let people down", "Ideas of guilt ", "Present illness is a punishment; delusions of guilt","Hallucinations of guilt"],
        choice: 0,
        explanation: "",
    },
    {
        text: "SUICIDE",
        answers: ["Absent", "Feels life is not worth living", "Wish I was dead", " Suicidal ideas or gestures", "Attempts at suicide"],
        choice: 0,
        explanation: "",
    },
    {
        text: "INSOMNIA - Initial (difficulty falling asleep)",
        answers: ["Absent", "Occasional", "Frequent"],
        choice: 0,
        explanation: "",
    },
    {
        text: "INSOMNIA - Middle (restless and disturbed during the night/waking during the night",
        answers: ["Absent", "Occasional", "Frequent"],
        choice: 0,
        explanation: "",
    },
    {
        text: "INSOMNIA - Delayed (waking in early hours of the morning and unable to fall asleep again))",
        answers: ["Absent", "Occasional", "Frequent"],
        choice: 0,
        explanation: "",
    },
    {
        text: "WORK AND INTERESTS",
        answers: ["No difficulty","Feelings of incapacity/listlessness/indecision", "Loss of interest in hobbies/social activiies", "Productivity decreased","Unable to work due to mood"],
        choice: 0,
        explanation: "",
    },
    {
        text: "RETARDATION (slowness of thought, speech, and activity; apathy; stupor)",
        answers: ["Absent","Slight retardation", "Obvious retardation", "Predominant retardation","Complete stupor"],
        choice: 0,
        explanation: "",
    },
    {
        text: "AGITATION",
        answers: ["Absent", "Occasional", "Frequent"],
        choice: 0,
        explanation: "",
    },
    {
        text: "ANXIETY - Psychic (internal anxiety)",
        answers: ["No difficulty","Tension and irritability", "Worrying about minor matters", "Apprehensive attitude","Fears"],
        choice: 0,
        explanation: "",
    },
    {
        text: "ANXIETY - Somatic (gastrointestinal, indigestion, cardiovascular, palpitation, headaches, respiratory, genito-urinary, etc)",
        answers: ["Absent","Mild", "Moderate", "Severe","Incapacitating"],
        choice: 0,
        explanation: "",
    },
    {
        text: "SOMATIC SYMPTOMS - Gastrointestinal (loss of appetite , heavy feeling in abdomen; constipation)",
        answers: ["Absent", "Mild", "Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "SOMATIC SYMPTOMS - General (heaviness in limbs, back or head; diffuse backache; loss of energy and fatiguability)",
        answers: ["Absent", "Mild", "Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "GENITAL SYMPTOMS - General (loss of libido, menstrual disturbances)",
        answers: ["Absent", "Mild", "Severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "HYPOCHONDRIASIS (somatic illness anxiety)",
        answers: ["Not present", "Self-absorption (bodily)", "Preoccupation with health", "Querulous attitude", " Hypochondriacal delusions"],
        choice: 0,
        explanation: "",
    },
    {
        text: "WEIGHT LOSS",
        answers: ["No weight loss", "Slight", "Obvious or severe"],
        choice: 0,
        explanation: "",
    },
    {
        text: "INSIGHT",
        answers: ["No loss", "Partial or doubtful loss", "Loss of insight"],
        choice: 0,
        explanation: "",
    },
];

// PHQ9
export const defaultPhq9= [
    {
        text: "Little interest or pleasure in doing things?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Feeling down, depressed, or hopeless?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Trouble falling or staying asleep, or sleeping too much?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Feeling tired or having little energy?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Poor appetite or overeating?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Feeling bad about yourself — or that you are a failure or have let yourself or your family down?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Trouble concentrating on things, such as reading the newspaper or watching television?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Moving or speaking so slowly that other people could have noticed? Or so fidgety or restless that you have been moving a lot more than usual?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
    {
        text: "Thoughts that you would be better off dead, or thoughts of hurting yourself in some way?",
        answers: ["Not at all","Several days","More than half of the days", "Nearly every day"],
        choice: 0,
        explanation: "",
    },
];

/* PHQ9 Scoring for tracking symptoms
Score >= 4 in minimal depression
5-9 - mild depression
10-14 - moderate depression
15-19 - moderately severe depression
20-27 - severe depression
*/


// Altman Self-Rating Mania Scale (ASRM
export const defaultAsrm = [
    {
        text: "Choose the statement that best describes your mood for the past week?",
        answers: ["I do not feel happier or more cheerful than usual.","I occasionally feel happier or more cheerful than usual.","I often feel happier or more cheerful than usual.", "I feel happier or more cheerful than usual most of the time.", "I feel happier of more cheerful than usual all of the time."],
        choice: 0,
        explanation: "",
    },
    {
        text: "Choose the statement that best describes your self-confidence for the past week?",
        answers: ["I do not feel more self-confident than usual.","I occasionally feel more self-confident than usual.", "I often feel more self-confident than usual.", "I frequently feel more self-confident than usual.", "I feel extremely self-confident all of the time."],
        choice: 0,
        explanation: "",
    },
    {
        text: "Choose the statement that best describes your sleep pattern for the past week?",
        answers: ["I do not need less sleep than usual.", "I occasionally need less sleep than usual.", "I often need less sleep than usual.", "I frequently need less sleep than usual.", "I can go all day and all night without any sleep and still not feel tired."],
        choice: 0,
        explanation: "",
    },
    {
        text: "Choose the statement that best describes your speech for the past week?",
        answers: ["I do not talk more than usual.", "I occasionally than usual.", "I often talk more than usual.", "I frequently talk more than usual.", "I talk constantly and cannot be interrupted."],
        choice: 0,
        explanation: "",
    },
    {
        text: "Choose the statement that best describes your activity level for the past week?",
        answers: ["I have not been more active (either socially, sexually, at work, home, or school) than usual.", "I have occasionally been more active than usual.", "I have often been more active than usual.", "I have frequently been more active than usual.", "I am constantly more active or on the go all the time."],
        choice: 0,
        explanation: "",
    },
];

/* ASRM Scoring
<6 - mania less likely
>= 6 mania/hypomnia is likely
*/


// SCREEN DATA FOR SURVEYS

export const adhdCurrentScreenData = {
    item: "ADHD-Current",
    type: "buttons",
    title: "Adult ADHD Self-Report Scale (ASRS) - Current Symptoms",
    subTitle: "Based on the WHO ASRS, v1.1",
    instructions: "As you answer each question, choose the option that best describes how you have felt and conducted yourself in the past 6 months.",
    sectionTitles: ["Part A", "Part B"],
    sectionSubTitles: ["", ""],
    surveys: [defaultASRSSurveyPartA, defaultASRSSurveyPartB],
};

export const adhdChildScreenData = {
    item: "ADHD-Childhood",
    type: "buttons",
    title: "Childhood ADHD Symptoms - Before Age 12",
    subTitle: "Adapted from the Adult Self-Report Scale",
    instructions: "As you answer each question, reflect on the option that best describes how you felt and conducted yourself BEFORE 12 years old",
    sectionTitles: ["Part A - Inattentive", "Part B - Hyperactive/Impulsive"],
    sectionSubTitles: ["", ""],
    surveys: [defaultADHDChildSurveyPartA, defaultADHDChildSurveyPartB],
};

export const adhdParentScreenData = {
    item: "ADHD-Parents",
    type: "buttons",
    title: "ADHD Survey for Parents- Symptoms Before Age 12",
    subTitle: "For parents or person who knew client well before age 12 - Adapted from the Adult Self-Report Scale",
    instructions: "As you answer each question, choose the option that best describes how YOU (THE PARENT) noticed the CLIENT conducted themselves BEFORE 12 years old",
    sectionTitles: ["Part A - Inattentive", "Part B - Hyperactive/Impulsive"],
    sectionSubTitles: ["", ""],
    surveys: [defaultADHDParentSurveyPartA, defaultADHDParentSurveyPartB],
};

// Definitions for future reference
const obsessionDef = "Obsessions are frequent, unwelcome, and intrusive thoughts.";
const compulsionDef = "Compulsions are repetitive behaviors or mental acts that you have a strong urge to repeat that are aimed at reducing your anxiety or preventing some dreaded event."

export const ocdYBOCSScreenData = {
    item: "OCD-YBOCS",
    type: "select",
    title: "OCD Survey",
    subTitle: "Evaluate obsessive and compulsive symptoms - Based on Yale-Brown Obsessive Compulsive Scale (Y-BOCS)",
    instructions: "As you answer each question, choose the option that best describes your experience",
    sectionTitles: ["Obsessions", "Compulsions"],
    sectionSubTitles: [obsessionDef, compulsionDef],
    surveys: [defaultYBOCSObsessions, defaultYBOCSCompulsions],
};

export const insomniaSeverityIndexScreenData = {
    item: "ISI",
    type: "select",
    title: "Insomnia Severity",
    subTitle: "Evaluate your insomnia - Based on the Insomnia Severity Index (ISI).",
    instructions: "Please rate the CURRENT (LAST 2 WEEKS) SEVERITY of your insomnia problems",
    sectionTitles: ["", ""],
    sectionSubTitles: ["", ""],
    surveys: [defaultInsomniaSeverityIndex, []],
};

export const depressionHamDScreenData = {
    item: "HAMD",
    type: "select",
    title: "Depression Rating Scale",
    subTitle: "Current depressive symptoms - Based on the Hamilton Depression Rating Scale (HAM-D). ",
    instructions: "Rate your experiences of your potential depressive symptoms noted below",
    sectionTitles: ["", ""],
    sectionSubTitles: ["", ""],
    surveys: [defaultHamD, []],
};

// SCREEN DATA FOR LOGS (except Sleep Log as requires special attention)

export const bipolarMoodTrackerScreenData = { 
    item: "Bipolar-Tracker",
    type: "select",
    title: "Bipolar Mood Tracker Log",
    subTitle: "Track and log your depressive and hypomanic/manic symptoms over time.",
    instructions: "Choose the option that best reflects your experience OVER THE PAST WEEK.",
    sectionTitles: ["Depressive Symptoms", "Manic/Hypomanic Symptoms"],
    sectionSubTitles: ["Based on the PHQ9 Depression Self-Report Screen", "Based on the Altman Self-Rating Mania Scale (ASRM)"],
    surveys: [defaultPhq9, defaultAsrm],
    dataTypes: ["phq9Score","asrmScore"], // names used to store in Firestore, will also always create a "date" and "comment" value by default
    tableDataTypes: [ // Headings and data types for the table, also first one will always be date and last will be comments that is clickable
        {
            title: "Depression/PHQ9",
            type: "value", //could be date
            dataType: "phq9Score",
            suffix: "",
        },
        {
            title: "Mania/ASRM",
            type: "value",
            dataType: "asrmScore",
            suffix: "",
        },
    ],
    graphDataTypes: [ // Graphs
        {
            title: "Bipolar Mood Tracker",
            xDataType: "date", //Date on the x axis
            numberOfYs: 2, // How many Y scores
            y1DataType: "phq9Score", // Y1 is left side
            y1Name: "Depression/PHQ9",
            y1Suffix: "",
            y2Treshold: 10, //show line threshold, >=10 is at least moderate depression
            y2DataType: "asrmScore", // Y2 is right side
            y2Name: "Mania/ASRM",
            y2Suffix: "",
            y2Threshold: 6, //>=6 is indicative of hypomania or mania
        },
    ],
};

// TO-DO: Create a unipolarMoodTracker that just has PHQ9
